module.exports = __webpack_public_path__ + "img/fashion_50.ec1ae713.jpg";